/* ------------------------------------------------------------------------------------------------------------------
   MOWOW Product page helpers (Impact)
   - Bundle add-to-cart: main product + gift + selected upsells, in one request
   - Collapsible text (see more/less)
   - Dialog open/close
------------------------------------------------------------------------------------------------------------------ */

(() => {
  const ROOT_SELECTOR = '[data-mowow-product-root]';

  
  
  function formatMoney(cents, format) {
    if (cents == null) return '';
    const formatString = format || '{{amount}}';

    let value = String(cents);
    if (typeof cents === 'string') value = cents.replace('.', '');

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = formatString.match(placeholderRegex);
    const placeholder = match ? match[1] : 'amount';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (number == null || isNaN(number)) return '0';
      const num = (number / 100.0).toFixed(precision);
      const parts = num.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    let formatted;
    switch (placeholder) {
      case 'amount':
        formatted = formatWithDelimiters(parseInt(value, 10), 2, ',', '.');
        break;
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(parseInt(value, 10), 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(parseInt(value, 10), 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(parseInt(value, 10), 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        formatted = formatWithDelimiters(parseInt(value, 10), 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        formatted = formatWithDelimiters(parseInt(value, 10), 0, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = formatWithDelimiters(parseInt(value, 10), 2, '\'', '.');
        break;
      default:
        formatted = formatWithDelimiters(parseInt(value, 10), 2, ',', '.');
    }

    return formatString.replace(placeholderRegex, formatted);
  }

  function getThemeMoneyFormat() {

    return window.themeVariables?.settings?.moneyFormat || '{{amount}}';
  }

  function updatePriceNotice(root, variant) {
    if (!root || !variant) return;
    const notices = root.querySelectorAll('[data-mowow-price-notice]');
    if (!notices.length) return;

    notices.forEach((notice) => {
      const vatRate = parseFloat(notice.getAttribute('data-vat-rate') || '0') || 0;
      const taxesIncluded = (notice.getAttribute('data-taxes-included') || '').toLowerCase() === 'true';
      const template = notice.getAttribute('data-template') || notice.getAttribute('data-template-tax') || 'Taxă inclusă ({price})';

      const priceCents = typeof variant.price === 'number' ? variant.price : parseInt(variant.price, 10);
      if (!Number.isFinite(priceCents)) return;

      const netCents = taxesIncluded && vatRate > 0
        ? Math.round((priceCents * 100) / (100 + vatRate))
        : priceCents;

      const netStr = formatMoney(netCents, getThemeMoneyFormat());
      const explicit = `${netStr} + TVA ${vatRate}%`;
      const line = template.replace(/\{price\}/g, explicit);

      const p = notice.querySelector('[data-mowow-taxes-line]');
      if (p) p.textContent = line;
    });
  }


  /* iNavi / 4G dynamic row (variant-based) */
  function parseJsonFromScript(scriptEl) {
    if (!scriptEl) return null;
    try {
      const txt = scriptEl.textContent || scriptEl.innerText || '';
      if (!txt.trim()) return null;
      return JSON.parse(txt);
    } catch (err) {
      return null;
    }
  }

  function getInavi4GModeMap(root) {
    if (!root) return null;
    if (root._mowowInavi4GMap) return root._mowowInavi4GMap;
    const script = root.querySelector('[data-mowow-inavi4g-variants]');
    const map = parseJsonFromScript(script) || {};
    root._mowowInavi4GMap = map;
    return map;
  }

  function computeInavi4GScenario(mode) {
    const m = String(mode || '').toLowerCase();
    const has4g = m.includes('4g');
    const hasInavi = m.includes('inavi') || m.includes('navi');
    if (has4g && hasInavi) return 'inavi4g';
    if (has4g || hasInavi) return '4g';
    return '';
  }

  function updateInavi4GRow(root, variant) {
    if (!root) return;
    const btns = root.querySelectorAll('[data-mowow-inavi4g]');
    if (!btns.length) return;

    const map = getInavi4GModeMap(root) || {};
    const id = variant && (variant.id || variant.variantId) ? String(variant.id || variant.variantId) : '';
    const mode = id ? map[id] : '';
    const scenario = computeInavi4GScenario(mode);

    btns.forEach((btn) => {
      if (!(btn instanceof HTMLElement)) return;

      const badge4g = btn.getAttribute('data-mowow-inavi4g-badge-4g') || '4G';
      const badgeInavi4g = btn.getAttribute('data-mowow-inavi4g-badge-inavi4g') || badge4g;

      const row4g = btn.getAttribute('data-mowow-inavi4g-row-4g') || '';
      const rowInavi4g = btn.getAttribute('data-mowow-inavi4g-row-inavi4g') || row4g;

      const shouldShow = !!scenario;
      btn.hidden = !shouldShow;

      const isInavi4g = scenario === 'inavi4g';

      const badgeEl = btn.querySelector('[data-mowow-inavi4g-badge]');
      if (badgeEl) badgeEl.textContent = isInavi4g ? badgeInavi4g : badge4g;

      const rowEl = btn.querySelector('[data-mowow-inavi4g-row]');
      if (rowEl) rowEl.textContent = isInavi4g ? rowInavi4g : row4g;

      const dialogId = btn.getAttribute('data-mowow-dialog-open');
      if (dialogId) {
        const dialog = document.getElementById(dialogId);
        if (dialog) {
          const pane4g = dialog.querySelector('[data-mowow-inavi4g-pane="4g"]');
          const paneInavi4g = dialog.querySelector('[data-mowow-inavi4g-pane="inavi4g"]');
          if (pane4g) pane4g.hidden = isInavi4g;
          if (paneInavi4g) paneInavi4g.hidden = !isInavi4g;
        }
      }
    });
  }

  function initInavi4GRows() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      const form = root.querySelector('form[is="product-form"]');
      const idInput = form ? findAssociatedControl(form, 'input[name="id"]') : root.querySelector('input[name="id"]');
      const id = parseInt(idInput?.value || '', 10);
      if (Number.isFinite(id) && id > 0) {
        updateInavi4GRow(root, { id });
      } else {
        updateInavi4GRow(root, { id: '' });
      }
    });
  }


function closestRoot(el) {
    return el ? el.closest(ROOT_SELECTOR) : null;
  }

  function getFormIdAttr(form) {
    // Avoid named property access clashes: always use attribute.
    return form?.getAttribute('id') || '';
  }

  function findAssociatedControl(form, selector) {
    if (!form) return null;

    // 1) inside form
    const inside = form.querySelector(selector);
    if (inside) return inside;

    // 2) outside but associated via form attribute
    const formId = getFormIdAttr(form);
    if (!formId) return null;

    const esc = (window.CSS && CSS.escape) ? CSS.escape(formId) : formId.replace(/"/g, '\\"');
    return document.querySelector(`${selector}[form="${esc}"]`);
  }

  function removeInjectedInputs(form) {
    form.querySelectorAll('[data-mowow-injected="true"]').forEach((n) => n.remove());
  }

  function injectHidden(form, name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = String(value ?? '');
    input.setAttribute('data-mowow-injected', 'true');
    form.appendChild(input);
    return input;
  }

  function setTempDisabled(control, disabled) {
    if (!control) return;
    if (disabled) {
      if (!control.hasAttribute('data-mowow-was-disabled')) {
        control.setAttribute('data-mowow-was-disabled', control.disabled ? '1' : '0');
      }
      control.disabled = true;
    } else {
      const was = control.getAttribute('data-mowow-was-disabled');
      if (was === null) return;
      control.disabled = was === '1';
      control.removeAttribute('data-mowow-was-disabled');
    }
  }

  function getGiftVariantId(root) {
    const node = root?.querySelector('[data-mowow-gift-variant-id]');
    const id = node?.getAttribute('data-mowow-gift-variant-id');
    if (!id) return null;
    const num = parseInt(id, 10);
    return Number.isFinite(num) && num > 0 ? num : null;
  }

  function parseMowowIdList(value) {
    return String(value || '')
      .split(',')
      .map((entry) => parseInt(String(entry || '').trim(), 10))
      .filter((id, index, array) => Number.isFinite(id) && id > 0 && array.indexOf(id) === index);
  }

  function findCampaignOfferGroup(node, mainVariantId) {
    if (!(node instanceof HTMLElement)) return null;

    const groups = Array.from(node.querySelectorAll('[data-mowow-campaign-offers-group]'))
      .filter((group) => group instanceof HTMLElement);
    if (!groups.length) return null;

    const scope = (node.getAttribute('data-mowow-campaign-scope') || 'selected_variants').toLowerCase();
    if (scope === 'all_variants') {
      return groups.find((group) => group.hasAttribute('data-mowow-default-group')) || null;
    }

    const mainId = parseInt(mainVariantId || '', 10);
    if (!Number.isFinite(mainId) || mainId <= 0) return null;

    return groups.find((group) =>
      parseMowowIdList(group.getAttribute('data-mowow-rule-variant-ids')).includes(mainId)
    ) || null;
  }

  function refreshCampaignOfferDisplay(root, variantIdOverride = null) {
    const scope = root instanceof HTMLElement || root instanceof Document ? root : document;

    scope.querySelectorAll('[data-mowow-campaign-offer]').forEach((node) => {
      if (!(node instanceof HTMLElement)) return;

      const productRoot = closestRoot(node) || document;
      const idInput = productRoot.querySelector('form[is="product-form"] input[name="id"]') || productRoot.querySelector('input[name="id"]');
      const mainVariantId = parseInt(variantIdOverride || idInput?.value || '', 10);
      const activeGroup = findCampaignOfferGroup(node, mainVariantId);

      node.hidden = !activeGroup;
      node.classList.toggle('is-active', Boolean(activeGroup));

      node.querySelectorAll('[data-mowow-campaign-offers-group]').forEach((group) => {
        if (!(group instanceof HTMLElement)) return;
        const isActive = group === activeGroup;
        group.hidden = !isActive;
        group.classList.toggle('is-active', isActive);

        if (!isActive) {
          group.querySelectorAll('[data-mowow-campaign-checkbox]').forEach((checkbox) => {
            if (checkbox instanceof HTMLInputElement) checkbox.checked = false;
          });
        }
      });

      const activeIds = activeGroup?.getAttribute('data-mowow-offer-variant-ids') || '';
      node.setAttribute('data-mowow-offer-variant-ids', activeIds);

      const firstId = parseMowowIdList(activeIds)[0];
      if (firstId) node.setAttribute('data-mowow-offer-variant-id', String(firstId));
      else node.removeAttribute('data-mowow-offer-variant-id');
    });
  }

  /**
   * Citeste O cutie de campanie.
   * Pana pe 17.09.2026 aici era `querySelector`, adica DOAR prima cutie din pagina: cu
   * doua blocuri de campanie, al doilea se afisa corect dar bonusul lui nu intra in cos.
   */
  function readCampaignOfferNode(node, mainVariantId) {
    if (!(node instanceof HTMLElement)) return null;

    const activeGroup = findCampaignOfferGroup(node, mainVariantId);
    if (!(activeGroup instanceof HTMLElement)) return null;

    const configuredVariantIds = parseMowowIdList(activeGroup.getAttribute('data-mowow-offer-variant-ids'));
    const autoAdd = (node.getAttribute('data-mowow-auto-add-offer') || '').toLowerCase() === 'true';
    const selectedVariantIds = Array.from(activeGroup.querySelectorAll('[data-mowow-campaign-checkbox]:checked'))
      .filter((checkbox) => checkbox instanceof HTMLInputElement && !checkbox.disabled)
      .map((checkbox) => parseInt(checkbox.value || '', 10))
      .filter((id, index, array) => Number.isFinite(id) && id > 0 && array.indexOf(id) === index);
    const variantIds = autoAdd
      ? configuredVariantIds
      : selectedVariantIds.filter((id) => configuredVariantIds.includes(id));
    const quantityMode = (node.getAttribute('data-mowow-offer-quantity-mode') || 'match_main').toLowerCase();
    const mode = (node.getAttribute('data-mowow-offer-mode') || 'bonus').toLowerCase();
    const discountCode = (activeGroup.getAttribute('data-mowow-discount-code') || node.getAttribute('data-mowow-discount-code') || '').trim();
    const campaignId = (node.getAttribute('data-mowow-campaign-id') || '').trim();

    return {
      variantId: variantIds[0] || null,
      variantIds,
      autoAdd,
      quantityMode,
      mode,
      discountCode,
      campaignId
    };
  }

  /** Toate cutiile de campanie din pagina, in ordinea din DOM. */
  function getCampaignOffersData(root, mainVariantId) {
    return Array.from(root?.querySelectorAll('[data-mowow-campaign-offer]') || [])
      .map((node) => readCampaignOfferNode(node, mainVariantId))
      .filter((offer) => offer && offer.variantIds.length > 0);
  }

  function getSelectedUpsellVariantIds(root) {
    const ids = [];
    root?.querySelectorAll('[data-mowow-upsell-checkbox]').forEach((cb) => {
      if (cb instanceof HTMLInputElement && cb.checked) {
        const v = cb.value || cb.getAttribute('data-variant-id');
        const id = parseInt(v || '', 10);
        if (Number.isFinite(id) && id > 0) ids.push(id);
      }
    });
    return ids;
  }

  function injectItemProperties(form, index, properties) {
    if (!properties || typeof properties !== 'object') return;

    Object.entries(properties).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') return;
      injectHidden(form, `items[${index}][properties][${key}]`, value);
    });
  }

  function normalizeDiscountCodes(value) {
    const raw = Array.isArray(value) ? value : String(value || '').split(',');
    const seen = new Set();
    const result = [];

    raw.forEach((entry) => {
      const code = String(entry || '').trim();
      if (!code) return;
      const key = code.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      result.push(code);
    });

    return result;
  }

  async function getAppliedDiscountCodes() {
    try {
      const response = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) return [];

      const cart = await response.json();
      if (!Array.isArray(cart?.discount_codes)) return [];

      return cart.discount_codes
        .filter((discount) => discount && discount.code)
        .map((discount) => discount.code);
    } catch (err) {
      return [];
    }
  }

  async function applyDiscountCodes(discountCodes) {
    const desiredCodes = normalizeDiscountCodes(discountCodes);
    if (!desiredCodes.length) return false;

    try {
      const existingCodes = await getAppliedDiscountCodes();
      const mergedCodes = normalizeDiscountCodes([...existingCodes, ...desiredCodes]);

      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ discount: mergedCodes.join(',') })
      });

      if (!response.ok) return false;

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return true;
    } catch (err) {
      return false;
    }
  }

  function prepareBundledAddToCart(e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    const root = closestRoot(form);
    if (!root) return;

    const giftVariantId = getGiftVariantId(root);
    const upsellVariantIds = getSelectedUpsellVariantIds(root);

    const idInput = findAssociatedControl(form, 'input[name="id"]:not([disabled])') || findAssociatedControl(form, 'input[name="id"]');
    const qtyInput = findAssociatedControl(form, 'input[name="quantity"]:not([disabled])') || findAssociatedControl(form, 'input[name="quantity"]');
    const sellingPlanInput = findAssociatedControl(form, 'input[name="selling_plan"]:not([disabled]), select[name="selling_plan"]:not([disabled])') || findAssociatedControl(form, 'input[name="selling_plan"], select[name="selling_plan"]');

    const mainVariantId = parseInt(idInput?.value || '', 10);
    const mainQty = parseInt(qtyInput?.value || '1', 10);
    const normalizedMainQty = Number.isFinite(mainQty) && mainQty > 0 ? mainQty : 1;

    if (!Number.isFinite(mainVariantId) || mainVariantId <= 0) {
      return;
    }

    const campaignOffers = getCampaignOffersData(root, mainVariantId);
    const bundledCampaignVariantIds = campaignOffers.reduce(
      (toate, oferta) => toate.concat(oferta.variantIds),
      []
    );

    if (!giftVariantId && bundledCampaignVariantIds.length === 0 && upsellVariantIds.length === 0) {
      form.removeAttribute('data-mowow-campaign-discount');
      return;
    }

    removeInjectedInputs(form);

    setTempDisabled(idInput, true);
    setTempDisabled(qtyInput, true);
    setTempDisabled(sellingPlanInput, true);

    const items = [];
    items.push({ id: mainVariantId, quantity: normalizedMainQty });

    if (giftVariantId) {
      items.push({ id: giftVariantId, quantity: 1 });
    }

    if (campaignOffers.length) {
      // Acelasi bonus pus in ambele cutii intra O SINGURA data in cos: altfel clientul
      // pleca cu doua standuri de spalare si-l platea pe al doilea.
      const variantePuse = new Set();

      campaignOffers.forEach((oferta) => {
        const campaignQty = oferta.quantityMode === 'single' ? 1 : normalizedMainQty;
        const campaignProperties = {
          _mowow_campaign_id: oferta.campaignId,
          _mowow_campaign_mode: oferta.mode,
          _mowow_campaign_parent_variant: String(mainVariantId),
          _mowow_campaign_discount_code: oferta.discountCode
        };

        oferta.variantIds.forEach((campaignVariantId) => {
          if (variantePuse.has(campaignVariantId)) return;
          variantePuse.add(campaignVariantId);
          items.push({
            id: campaignVariantId,
            quantity: campaignQty,
            properties: campaignProperties
          });
        });
      });

      // normalizeDiscountCodes taie duplicatele si spatiile
      const coduri = campaignOffers.map((oferta) => oferta.discountCode).filter(Boolean);
      if (coduri.length) {
        form.setAttribute('data-mowow-campaign-discount', coduri.join(','));
      } else {
        form.removeAttribute('data-mowow-campaign-discount');
      }
    } else {
      form.removeAttribute('data-mowow-campaign-discount');
    }

    upsellVariantIds.forEach((id) => items.push({ id, quantity: 1 }));

    items.forEach((item, index) => {
      injectHidden(form, `items[${index}][id]`, item.id);
      injectHidden(form, `items[${index}][quantity]`, item.quantity);
      injectItemProperties(form, index, item.properties);
    });

    if (sellingPlanInput && sellingPlanInput.value) {
      injectHidden(form, 'items[0][selling_plan]', sellingPlanInput.value);
    }

    form.setAttribute('data-mowow-bundled-submit', 'true');
  }

  function cleanupAfterSubmit(form, { clearCampaignState = false } = {}) {
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('data-mowow-bundled-submit') !== 'true') return;

    const idInput = findAssociatedControl(form, 'input[name="id"]:not([disabled])') || findAssociatedControl(form, 'input[name="id"]');
    const qtyInput = findAssociatedControl(form, 'input[name="quantity"]:not([disabled])') || findAssociatedControl(form, 'input[name="quantity"]');
    const sellingPlanInput = findAssociatedControl(form, 'input[name="selling_plan"]:not([disabled]), select[name="selling_plan"]:not([disabled])') || findAssociatedControl(form, 'input[name="selling_plan"], select[name="selling_plan"]');

    setTempDisabled(idInput, false);
    setTempDisabled(qtyInput, false);
    setTempDisabled(sellingPlanInput, false);

    removeInjectedInputs(form);
    form.removeAttribute('data-mowow-bundled-submit');

    if (clearCampaignState) {
      form.removeAttribute('data-mowow-campaign-discount');
    }
  }

  async function handlePostAddCampaign(form) {
    if (!(form instanceof HTMLFormElement)) return;

    const discountCodes = normalizeDiscountCodes(form.getAttribute('data-mowow-campaign-discount') || '');
    form.removeAttribute('data-mowow-campaign-discount');

    if (!discountCodes.length) return;
    await applyDiscountCodes(discountCodes);
  }

  function setupBundledAddToCart() {
    document.querySelectorAll(`${ROOT_SELECTOR} form[is="product-form"]`).forEach((form) => {
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('data-mowow-bundle-init') === '1') return;

      form.setAttribute('data-mowow-bundle-init', '1');

      form.addEventListener('submit', prepareBundledAddToCart, { capture: true });
      form.addEventListener('change', () => refreshCampaignOfferDisplay(closestRoot(form) || document));
      form.addEventListener('variant:add', () => {
        cleanupAfterSubmit(form);
        handlePostAddCampaign(form);
        refreshCampaignOfferDisplay(closestRoot(form) || document);
      });
      form.addEventListener('cart:error', () => cleanupAfterSubmit(form, { clearCampaignState: true }));
    });

    refreshCampaignOfferDisplay(document);
  }

  /* Collapsible: toggle is-expanded on container */
  function setupCollapsibles() {
    // Use capture to avoid conflicts with theme handlers that stop propagation
    document.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;
      const btn = e.target.closest('[data-mowow-collapsible-toggle]');
      if (!(btn instanceof HTMLElement)) return;

      const wrapper = btn.closest('[data-mowow-collapsible]');
      if (!(wrapper instanceof HTMLElement)) return;

      const expanded = wrapper.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      const more = wrapper.querySelector('[data-mowow-toggle-more]');
      const less = wrapper.querySelector('[data-mowow-toggle-less]');
      if (more) more.hidden = expanded;
      if (less) less.hidden = !expanded;

      const icon = wrapper.querySelector('[data-mowow-toggle-icon]');
      if (icon) icon.style.transform = expanded ? 'rotate(180deg)' : 'rotate(0deg)';
    }, true);

    function refreshCollapsibleToggles() {
      document.querySelectorAll('[data-mowow-collapsible]').forEach((wrap) => {
        const content = wrap.querySelector('.mowow-collapsible__content');
        const btn = wrap.querySelector('[data-mowow-collapsible-toggle]');
        if (!content || !btn) return;

        // Measure overflow in collapsed state
        const wasExpanded = wrap.classList.contains('is-expanded');
        if (wasExpanded) wrap.classList.remove('is-expanded');
        const needsToggle = content.scrollHeight > content.clientHeight + 1;
        btn.hidden = !needsToggle;
        if (wasExpanded) wrap.classList.add('is-expanded');
      });
    }

    // Initial + responsive refresh
    refreshCollapsibleToggles();
    window.addEventListener('resize', refreshCollapsibleToggles);
  }

  /* Dialogs */
  function setupDialogs() {
    function safeShow(dialog) {
      if (!dialog) return;
      const isNativeDialog = typeof HTMLDialogElement !== 'undefined' && dialog instanceof HTMLDialogElement;
      if (isNativeDialog) {
        try {
          if (!dialog.open) dialog.showModal();
        } catch (err) {
          dialog.setAttribute('open', '');
        }
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function safeClose(dialog) {
      if (!dialog) return;
      const isNativeDialog = typeof HTMLDialogElement !== 'undefined' && dialog instanceof HTMLDialogElement;
      if (isNativeDialog) {
        try {
          dialog.close();
        } catch (err) {
          dialog.removeAttribute('open');
        }
      } else {
        dialog.removeAttribute('open');
      }
    }

    // Capture phase: run before theme handlers that might stop propagation
    document.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;

      const openBtn = e.target.closest('[data-mowow-dialog-open]');
      if (openBtn instanceof HTMLElement) {
        const targetId = openBtn.getAttribute('data-mowow-dialog-open');
        if (targetId) {
          const dialog = document.getElementById(targetId);
          if (dialog) {
            e.preventDefault();
            e.stopPropagation();
            safeShow(dialog);
            return;
          }
        }
      }

      const closeBtn = e.target.closest('[data-mowow-dialog-close]');
      if (closeBtn instanceof HTMLElement) {
        const dialog = closeBtn.closest('dialog');
        if (dialog) {
          e.preventDefault();
          e.stopPropagation();
          safeClose(dialog);
        }
      }
    }, true);

    // Backdrop click to close
    document.querySelectorAll(`${ROOT_SELECTOR} dialog.mowow-modal`).forEach((dialog) => {
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) safeClose(dialog);
      });
    });
  }

  
  function setupDynamicPriceNotice() {
    document.addEventListener('variant:change', (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      const root = closestRoot(form);
      if (!root) return;
      const variant = e.detail?.variant;
      if (!variant) return;
      updatePriceNotice(root, variant);
      updateInavi4GRow(root, variant);
      refreshCampaignOfferDisplay(root, variant.id);
    });
  }

function init() {
    setupBundledAddToCart();
    setupDynamicPriceNotice();
    setupCollapsibles();
    setupDialogs();
    initInavi4GRows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    setupBundledAddToCart();
    initInavi4GRows();
  });
})();



/* =========================================================
   MOWOW Patch B5.2 — Collapsible reliability
   - Impact updates sections dynamically; re-init on section load
   - Use ResizeObserver to recompute heights
   ========================================================= */
(function(){
  function initOneCollapsible(root){
    const wrap = root;
    if (!wrap || wrap.dataset.mowowInit === '1') return;
    const content = wrap.querySelector('.mowow-collapsible__content');
    const toggle  = wrap.querySelector('.mowow-collapsible__toggle');
    if (!content || !toggle) return;

    wrap.dataset.mowowInit = '1';

    const collapsedHeight = parseInt(wrap.dataset.collapsedHeight || '64', 10); // px
    function apply(){
      // If not in DOM flow (e.g., in closed dialog), defer
      const sh = content.scrollHeight;
      if (!sh || sh < 10) return;

      const isOverflow = sh > (collapsedHeight + 8);
      wrap.dataset.hasOverflow = isOverflow ? '1' : '0';
      toggle.style.display = isOverflow ? '' : 'none';

      const expanded = wrap.dataset.state === 'expanded';
      content.style.maxHeight = expanded ? (sh + 'px') : (collapsedHeight + 'px');
    }

    // initial state
    if (!wrap.dataset.state) wrap.dataset.state = 'collapsed';

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const expanded = wrap.dataset.state === 'expanded';
      wrap.dataset.state = expanded ? 'collapsed' : 'expanded';
      toggle.textContent = expanded ? (toggle.dataset.moreLabel || 'Vezi mai mult') : (toggle.dataset.lessLabel || 'Vezi mai puțin');
      apply();
    });

    // Recompute on image load / font load / resize
    const ro = ('ResizeObserver' in window) ? new ResizeObserver(() => apply()) : null;
    if (ro) ro.observe(content);

    // Wait a tick to ensure layout
    requestAnimationFrame(() => { apply(); });
    window.addEventListener('load', apply, { once: true });
  }

  function initCollapsibles(scope=document){
    scope.querySelectorAll('.mowow-collapsible').forEach(initOneCollapsible);
  }

  // Hook into Shopify theme editor section loads
  document.addEventListener('DOMContentLoaded', () => initCollapsibles(document));
  document.addEventListener('shopify:section:load', (e) => initCollapsibles(e.target));
  document.addEventListener('shopify:section:select', (e) => initCollapsibles(e.target));

  // Fallback for dynamic renders (variant switches etc.)
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations){
      for (const n of m.addedNodes){
        if (n && n.nodeType === 1){
          if (n.matches && n.matches('.mowow-collapsible')) initOneCollapsible(n);
          if (n.querySelectorAll) initCollapsibles(n);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });

})();


